import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto py-20 text-center">
      <XCircle className="w-16 h-16 mx-auto text-muted-foreground" />
      <h1 className="font-kannada-heading text-3xl mt-6">ಪಾವತಿ ರದ್ದುಗೊಂಡಿದೆ</h1>
      <p className="text-muted-foreground mt-2">ಯಾವುದೇ ಶುಲ್ಕ ವಿಧಿಸಲಾಗಿಲ್ಲ.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Button asChild className="rounded-none">
          <Link to="/subscribe">ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-none">
          <Link to="/">ಮುಖಪುಟಕ್ಕೆ</Link>
        </Button>
      </div>
    </div>
  );
}
